import { render, staticRenderFns } from "./FeedbackPartners.vue?vue&type=template&id=47bff152"
import script from "./FeedbackPartners.vue?vue&type=script&lang=ts"
export * from "./FeedbackPartners.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports